"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TwitchIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M.96 0L0 2.609v10.434h3.519V15h1.92l1.92-1.957h2.88l3.84-3.912V0H.96zm1.28 1.304H12.8v7.174l-2.241 2.283h-3.52l-1.918 1.954v-1.954H2.239V1.303zm3.52 6.522h1.28V3.914H5.76v3.912zm3.519 0h1.28V3.914h-1.28v3.912z"
  })))
});
TwitchIcon.displayName = 'TwitchIcon';
var _default = exports.default = TwitchIcon;